import React from "react";
import {
  Box,
  Heading,
  Text,
  useColorMode,
} from "@chakra-ui/react";

const InsightsSection = ({ title, description, children }) => {
  const { colorMode } = useColorMode();
  const cardBg = colorMode === "light" ? "white" : "gray.700";
  const headingColor = colorMode === "light" ? "gray.700" : "gray.100";
  const subColor = colorMode === "light" ? "gray.500" : "gray.400";

  return (
    <Box bg={cardBg} rounded="lg" boxShadow="sm" p={4}>
      <Heading size="sm" mb={1} color={headingColor}>
        {title}
      </Heading>
      {description && (
        <Text fontSize="xs" color={subColor} mb={3}>
          {description}
        </Text>
      )}
      {children}
    </Box>
  );
};

export default InsightsSection;
